/** Step-5 preview only. SQL internal.compliance_event_fanout remains authoritative.
 * Reasons and their order mirror migration 20435000002507 exactly. */
export function complianceEventFanout(input: { people?: unknown; what?: unknown; care?: unknown }) {
  const people = Array.isArray(input.people) ? input.people : [];
  const chips = Array.isArray(input.what) ? input.what : [];
  const careInput =
    input.care && typeof input.care === 'object' ? (input.care as Record<string, unknown>) : {};
  let resident = careInput.client_id != null && careInput.client_id !== '';
  let worker = false,
    clientHurt = false,
    workerHurt = false,
    workerThreatened = false,
    visitorHurt = false;
  const hurt = (value: unknown) => ['yes', 'unknown', 'not_sure'].includes(String(value));
  for (const item of people) {
    const person = item && typeof item === 'object' ? (item as Record<string, unknown>) : {};
    if (person.kind === 'CLIENT') {
      resident = true;
      clientHurt ||= hurt(person.hurt);
    } else if (['SELF', 'STAFF', 'AGENCY'].includes(String(person.kind))) {
      worker = true;
      workerHurt ||= hurt(person.hurt);
      workerThreatened ||= person.threatened === true;
    } else if (person.kind === 'VISITOR') visitorHurt ||= hurt(person.hurt);
  }
  let care = false,
    whs = false;
  const reasons: string[] = [];
  const rule = (match: boolean, register: 'care' | 'whs', reason: string) => {
    if (match) {
      if (register === 'care') care = true;
      else whs = true;
      reasons.push(reason);
    }
  };
  rule(clientHurt, 'care', 'client_hurt');
  rule(
    resident &&
      [
        'medication',
        'allegation',
        'missing_person',
        'restraint',
        'unexplained_injury',
        'skin_injury',
        'death',
      ].some((c) => chips.includes(c)),
    'care',
    'care_chip',
  );
  rule(workerHurt, 'whs', 'worker_hurt');
  rule(visitorHurt, 'whs', 'visitor_hurt');
  rule(
    ['hazard', 'needlestick', 'substance_exposure', 'vehicle', 'lifting'].some((c) =>
      chips.includes(c),
    ),
    'whs',
    'whs_chip',
  );
  rule(chips.includes('fall') && resident, 'care', 'fall_resident');
  rule(chips.includes('fall') && worker, 'whs', 'fall_worker');
  rule(chips.includes('aggression') && resident, 'care', 'aggression_resident');
  rule(
    chips.includes('aggression') && (workerHurt || workerThreatened),
    'whs',
    'aggression_worker',
  );
  if (!care && !whs) rule(true, resident ? 'care' : 'whs', resident ? 'triage_care' : 'triage_whs');
  return { care, whs, reasons };
}
